import { useSelector } from 'react-redux'
import { CampaignId } from '@feedyou-ai/feedbot-schema'
import { campaignSelector } from '../selectors/selectors'

export function useCampaign(campaignId: CampaignId) {
  return useSelector(campaignSelector(campaignId))
}
